<div id="gnb-instances-configuration">
  @let cols = columns;

  <table>
    <thead>
      <tr>
        <th></th>
        @for (column of cols; track column.control) {
          <th>{{ column.label }}</th>
        }
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="row-label">Fronthaul Type</td>
        @for (column of cols; track column.control) {
          @if (column.isRadio) {
            <td>
              <div class="dropdown">
                <button
                  type="button"
                  class="form-control dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  {{
                    column.control.value.fronthaulType
                      ? FRONTHAUL_TYPE_CONFIG[
                          column.control.value.fronthaulType
                        ].label
                      : "Select type"
                  }}
                </button>
                <ul class="dropdown-menu w-100">
                  @for (type of AVAILABLE_FRONTHAUL_TYPES; track type) {
                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        [class.selected]="
                          column.control.value.fronthaulType === type
                        "
                        (click)="
                          column.control.controls.fronthaulType.patchValue(type)
                        "
                      >
                        {{ FRONTHAUL_TYPE_CONFIG[type].label }}
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </td>
          } @else {
            <td class="na-cell">—</td>
          }
        }
      </tr>

      <tr>
        <td class="row-label">Frequency Range</td>
        @for (column of cols; track column.control) {
          @if (column.isRadio) {
            <td>
              <div class="dropdown">
                <button
                  type="button"
                  class="form-control dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  {{ column.control.value.frequencyRange ?? "Select range" }}
                </button>
                <ul class="dropdown-menu w-100">
                  @for (range of AVAILABLE_FREQUENCY_RANGES; track range) {
                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        [class.selected]="
                          column.control.value.frequencyRange === range
                        "
                        (click)="
                          column.control.controls.frequencyRange.patchValue(
                            range
                          )
                        "
                      >
                        {{ range }}
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </td>
          } @else {
            <td class="na-cell">—</td>
          }
        }
      </tr>

      <tr>
        <td class="row-label">Duplex Mode</td>
        @for (column of cols; track column.control) {
          @if (column.isRadio) {
            <td>
              <div class="dropdown">
                <button
                  type="button"
                  class="form-control dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  {{ column.control.value.duplexMode ?? "Select mode" }}
                </button>
                <ul class="dropdown-menu w-100">
                  @for (mode of AVAILABLE_DUPLEX_MODES; track mode) {
                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        [class.selected]="
                          column.control.value.duplexMode === mode
                        "
                        (click)="
                          column.control.controls.duplexMode.patchValue(mode)
                        "
                      >
                        {{ mode }}
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </td>
          } @else {
            <td class="na-cell">—</td>
          }
        }
      </tr>

      <tr>
        <td class="row-label">RF Simulator</td>
        @for (column of cols; track column.control) {
          @if (column.isRadio) {
            <td>
              <div class="form-switch">
                <input
                  type="checkbox"
                  role="switch"
                  class="form-check-input"
                  [formControl]="column.control.controls.rfSimulatorEnabled"
                />
              </div>
            </td>
          } @else {
            <td class="na-cell">—</td>
          }
        }
      </tr>

      @if (showRanStackRow) {
      <tr>
        <td class="row-label">RAN Stack</td>
        @for (column of cols; track column.control) {
          <td>
            <div class="dropdown">
              <button
                type="button"
                class="form-control dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                {{ column.control.value.ranMode ?? "Select mode" }}
              </button>
              <ul class="dropdown-menu w-100">
                @for (mode of AVAILABLE_RAN_MODES; track mode) {
                  <li>
                    <button
                      type="button"
                      class="dropdown-item"
                      [class.selected]="column.control.value.ranMode === mode"
                      (click)="column.control.controls.ranMode.patchValue(mode)"
                    >
                      {{ mode }}
                    </button>
                  </li>
                }
              </ul>
            </div>
          </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>
